document.addEventListener("DOMContentLoaded", function () {
    function waitForCookieConsent(callback, timeout = 5000, interval = 100) {
        const start = Date.now();

        (function check() {
            if (typeof CookieConsent !== "undefined") {
                callback();
            } else if (Date.now() - start < timeout) {
                setTimeout(check, interval);
            } else {
                console.warn("CookieConsent was not loaded within timeout");
            }
        })();
    }

    waitForCookieConsent(function () {
        document.addEventListener("click", function (event) {
            const target = event.target.closest("[data-custom-target='cookie-popup']");
            if (target) {
                event.preventDefault();
                CookieConsent.renew();
            }
        });
    });
});
